"use client";

import {
  type CapacityFields,
  resolvePublicEventCapacity,
} from "@/utils/publicEventCapacity";
import { useTranslations } from "next-intl";
import { useLiveCapacity } from "./LiveCapacity";

/**
 * The sidebar's spots-left line, kept live by the nearest LiveCapacityProvider.
 * The status region stays mounted so a screen reader announces the update.
 */
export default function CapacityHint({ initial }: { initial: CapacityFields }) {
  const t = useTranslations();
  const capacity = resolvePublicEventCapacity(useLiveCapacity(initial));

  return (
    <div role="status">
      {capacity.status !== "open" && (
        <p
          className="mt-5 text-sm font-medium text-muted-foreground"
          data-testid="capacity-hint"
        >
          {capacity.status === "full"
            ? t("publicEventSignup.capacityFull")
            : t("publicEventSignup.spotsLeft", {
                count: capacity.spotsRemaining,
              })}
        </p>
      )}
    </div>
  );
}
